// extracted by mini-css-extract-plugin
export var compactFilters = "_fc-4";
export var detailImage = "_fc-1";
export var dropdownContainer = "_fc-2";
export var imageContainer = "_fc-0";
export var selectedCard = "_fc-3";